'use strict';

var postcss = require('postcss');
var Px2rem = require('px2rem');

module.exports = postcss.plugin('postcss-px2rem', function (options) {
  return function (css, result) {
    var oldCssText = css.toString();
    var px2remIns = new Px2rem(options);
    var newCssText = px2remIns.generateRem(oldCssText);
    var newCssObj = postcss.parse(newCssText);
    result.root = newCssObj;
  };
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/postcss-px2rem/lib/index.js
// module id = 3995
// module chunks = 1